<template>
  <div>
    <div class="nocart" v-if='!itemList'>
      <img src="../assets/image/shopcart/nocart.png">
    </div>
    <div v-else class="shopcart-container">
      <div class="shopcart-edit">
        <p v-if="!showEdit" @click="editCart('edit')">编辑</p>
        <p v-else @click="editCart('finish')">完成</p>
      </div>
      <div class="shopcart-header">
          <p>全部商品<span>{{totalQuantity}}</span></p>
          <p v-if='freight==0'><img @click="showFreight" src="../assets/image/shopcart/warning.png">订单已免运费</p>
      </div>
      <div class="shopcart-list">
            <div class="shopcart-item" v-for="item in mainList">
                <div class="i-select-coupon">
                  <p @click="selectCoupon(item.product8D)">选择优惠券></p>
                </div>
                <div v-if='item.appliedCoupons' class="i-selected-coupon">
                  <p class="coupon-icon">优惠券</p>
                  <p class="coupon-info">使用优惠券{{item.appliedCoupons[0].code}},购买该产品可优惠RMB100</p>
                  <img @click="removeCoupon(item.appliedCoupons[0].code)" src="../assets/image/shopcart/close.png">
                </div>
                <div v-if='pro.consumedEntries[0].product8D==item.product8D' v-for='pro in promotion_item' class="i-selected-coupon">
                  <p class="coupon-icon">促销</p>
                  <p class="coupon-info">{{pro.message}}</p>
                </div>
                <div class="i-main">
                  <div class="i-product">
                    <input v-model="checkedNo" :id="'check'+item.entryNumber" type="checkbox" :value="item.entryNumber">
                    <label v-show="showEdit" :for="'check'+item.entryNumber"/>
                    <div class="p-img">
                      <img :src="BASE_URL+item.imgURL">
                      <p v-if='item.message=="outOfStock"' class="p-status">缺货</p>
                    </div>
                    <div class="p-info">
                      <p class="info-title">{{item.name}}</p>
                      <p class="info-price">&nbsp;&nbsp;&nbsp;价格 RMB{{item.orginalPrice}}</p>
                      <p class="info-price">尊享价 <span>RMB{{item.grossPrice}}</span></p>
                      <div class="input-div">
                        <div @click="changeCart(item.entryNumber,item.quantity/1-1,'U')" class="decrease">-</div>
                        <input disabled type="number" v-model="item.quantity">
                        <div @click="changeCart(item.entryNumber,item.quantity/1+1,'U')" class="increase">+</div>
                      </div>
                    </div>
                  </div>
                  <div class="gift-list" v-for="foc in item.foc">
                    <div class="gift-item">
                      <div class="gift-main">
                        <div class="g-img">
                          <img :src="BASE_URL+foc.imgURL">
                          <p v-if='item.message=="outOfStock"' class="g-status">缺货</p>
                        </div>
                        <div class="g-info">
                          <p class="g-icon">赠品</p>
                          <p class="g-name">{{foc.name}}</p>
                        </div>
                      </div>
                      <p class="gift-num">x{{foc.quantity}}</p>
                    </div>
                  </div>
                </div>
              <div class="i-total">
                <p class="total-price">小计 RMB {{item.netPrice}}</p>
                <p class="total-coupon" v-if='item.discount!=0'>优惠 RMB {{item.discount}}</p>
              </div>
            </div>
        </div>
      <div v-if="!showEdit" class="shopcart-footer">
        <div v-if='isShowPromotion&&promotion_head&&promotion_head[1]' class="shopcart-notice">
          <p v-for='pro in promotion_head' v-if='pro.promotion.description'><span>促销</span>{{pro.promotion.description}}</p>
          <img @click="closePromotion" src="../assets/image/shopcart/close.png">
        </div>
          <div class="shopcart-settle">
          <!--<p class="s-select">选择优惠券></p>-->
          <div class="s-price">
            <p class="price-total">总金额: RMB {{finalPrice}}</p>
            <p v-if='totalHeadDiscount' class="price-coupon">总计优惠: RMB {{totalDiscount}}</p>
          </div>
          <div @click="checkout" class="s-btn">去结算</div>
        </div>
      </div>
      <div v-else class="shopcart-footer-edit">
        <div @click="removeOrMove('moveAll')">全部缺货商品移入心愿单</div>
        <div @click="removeOrMove('move')">移入心愿单</div>
        <div @click="pop('delete')">删除</div>
      </div>
      <div>
        <div v-show="showCoupon" class="gray-bg"></div>
        <div v-show="showCoupon" class="coupon-zone">
          <p class="coupon-tit">优惠券</p>
          <div class="coupon-search">
            <input type="text" placeholder="输入您所持有的优惠券号码">
            <div class="use-btn">使用优惠券</div>
          </div>
          <div class="coupon-list">
            <div class="coupon-item">
              <input type="radio">
              <p>使用优惠券CDSDFS,购买该产品可优惠RMB 100</p>
            </div>
            <div class="coupon-item">
              <input type="radio">
              <p>使用优惠券CDSDFS,购买该产品可优惠RMB 100</p>
            </div>
          </div>
          <div class="ensure-btn">确认</div>
        </div>
      </div>
      <popup @cut="removeOrMove('delete')" @hidePopup='hidePopup' @continueCheck='continueCheck' @movewish="removeOrMove('move')" v-show='popupShow' :des='popupDes' :type='popupType'></popup>
    </div>
  </div>
</template>
<style scoped lang="less">
  .nocart {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    img {
      width: 28%;
    }
  }
  .shopcart-container {
    background-color: rgb(242,242,242);
  }
  .shopcart-edit {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 45px;
    line-height: 45px;
    background-color: #ffffff;
    z-index: 11;
    p {
      float: right;
      padding-right: 18px;
      font-size: 14px;
      color: #585858;
    }
  }
  .shopcart-header {
    z-index: 11;
    position: fixed;
    top: 45px;
    left: 0;
    right: 0;
    padding: 0 15px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #4d4d4d;
    background-color: rgb(218,218,218);
    p {
      display: flex;
      align-items: center;
    }
    span {
      color: #0a83d7;
    }
    img {
      width: 14px;
      height: 14px;
    }
  }
.shopcart-list {
  margin-top: 75px;
  margin-bottom: 115px;
  padding-top: 15px;
  background-color: rgb(242,242,242);
  .shopcart-item {
    padding: 0 15px;
    background-color: #ffffff;
    margin-bottom: 15px;
    .i-select-coupon {
      text-align: right;
      p{
        display: inline-block;
        background-color: rgb(181,0,0);
        font-size: 10px;
        color: #ffffff;
        margin: 7px 0;
      }
    }
    .i-selected-coupon {
      display: flex;
      align-items: center;
      margin-bottom: 7px;
      .coupon-icon {
        border: 1px solid rgb(181,0,0);
        font-size: 9px;
        color: rgb(181,0,0);
        margin-right: 6px;
      }
      .coupon-info {
        font-size: 10px;
        color: #808080;
        max-width: 75%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      img {
        width: 12px;
        height: 12px;
        margin-left: 5px;
      }
    }
    .i-main {
      border-top: 1px dotted #808080;
      border-bottom: 1px dotted #808080;
    }
    .i-product {
      display: flex;
      position: relative;
      margin: 12px 0;

      input[type=checkbox] {
        display: none;
      }
      label {
        position: relative;
        width: 20px;
      }
      label:before {
        content: '';
        display: inline-block;
        width: 14px;
        height: 14px;
        position: absolute;
        top: 38px;
        left: 0;
        background:url("../assets/image/order/d_check.png") no-repeat;
        background-size:100% auto;
      }
      input[type=checkbox]:checked + label:before{
        background:url("../assets/image/order/d_checked.png") no-repeat;
        background-size:100% auto;
      }
      .p-img {
        width: 90px;
        height: 90px;
        border: 1px solid #8d8d8d;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        img {
          width: 100%;
        }
        .p-status {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.3);
          font-size: 12px;
          color: #ffffff;
          text-align: center;
          line-height: 90px;
        }
      }
      .p-info {
        padding-left: 15px;
        .info-title {
          font-size: 11px;
          margin-bottom: 20px;
        }
        .info-price {
          font-size: 10px;
          margin-bottom: 5px;
          color: #999999;
        }
        span {
          color: #0a83d7;
        }
        .input-div {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 90px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #8d8d8d;
          .decrease {
            width: 29px;
            height: 30px;
            position: absolute;
            left: 0px;
            top: 0px;
          }
          input {
            width: 30px;
            height: 28px;
            position: absolute;
            left: 30px;
            top:0;
            border: none;
            padding: 0;
            text-align: center;
            border-left: 1px solid #8d8d8d;
            border-right: 1px solid #8d8d8d;
          }
          .increase {
            width: 29px;
            height: 30px;
            position: absolute;
            right: 0px;
            top: 0px;
          }
        }
      }
    }
    .gift-list {
      background-color: rgb(245,245,245);
      margin-bottom: 12px;
      padding: 10px 40px 10px 27px;
      .gift-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 5px;
        .gift-main {
          display: flex;
          align-items: flex-start;
        }
        .gift-num {
          color: #706f6f;
          font-size: 10px;
        }
        .g-img {
          width: 40px;
          height: 40px;
          border: 1px solid #8d8d8d;
          position: relative;
          img {
            width: 90%;
          }
        }
        .g-status {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.3);
          font-size: 11px;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
        }
        .g-info {
          font-size: 10px;
          margin-left: 11px;
        }
        .g-icon {
          border: 1px solid rgb(181,0,0);
          color: rgb(181,0,0);
          display: inline-block;
          background-color: #ffffff;
        }
        .g-name {
          color: #706f6f;
        }
      }
    }
    .i-total {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 12px 0 28px 0;
      .total-price {
        font-size: 11px;
        color: #0a83d7;
      }
      .total-coupon {
        font-size: 9px;
        color: #b50000;
        margin-top: 6px;
      }
    }
  }
}
.shopcart-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffff;
  box-shadow: 0 -1px 5px #999999;
  padding: 15px;
}
  .shopcart-notice{
    position: relative;
    margin-bottom: 20px;
    p {
      color: #808080;
      font-size: 10px;
      border-bottom: 1px dotted #8d8d8d;
      padding: 5px 0;
      margin-right: 20px;
    }
    span {
      color: #0a83d7;
    }
    img {
      position: absolute;
      right: 0;
      bottom: 8px;
      width: 12px;
      height: 12px;
    }
  }
  .shopcart-settle {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    .s-select {
      font-size: 10px;
      color: #ffffff;
      background-color: #b50000;
    }
    .s-price {
      text-align: end;
      margin-right: 15px;
      .price-total {
        font-size: 12px;
        color: #0a83d7;
      }
      .price-coupon {
        font-size: 10px;
        color: #999999;
      }
    }
    .s-btn {
      width: 120px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background-color: #0a83d7;
      font-size: 13px;
      color: #ffffff;
      max-width: 34%;
    }
  }
  .shopcart-footer-edit {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background-color: #d2e5f0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #a6c0d6;
    div{
      font-size: 12px;
      text-align: center;
      height: 50px;
      line-height: 50px;
      color: #3685d1;
      &:nth-of-type(1) {
        width: 45%;
      }
      &:nth-of-type(2) {
        width: 35%;
        border-left: 1px solid #a6c0d6;
        border-right: 1px solid #a6c0d6;
      }
      &:nth-of-type(3) {
        width: 20%;
      }
    }
  }
  .gray-bg {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0,0,0,0.3);
    z-index: 100;
  }
  .coupon-zone {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    padding-top: 15px;
    z-index: 101;
    .coupon-tit {
      font-size: 15px;
      color: #6b6b6b;
      margin-left: 18px;
      margin-bottom: 12px;
    }
    .coupon-search {
      margin: 0 18px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      input {
        width: 60%;
        height: 33px;
        color: #6b6b6b;
        background-color: rgb(242,242,242);
        border: none;
        outline: none;
        padding: 0 4px;
      }
      .use-btn {
        width: 90px;
        height: 33px;
        line-height: 33px;
        text-align: center;
        background-color: #b50000;
        font-size: 13px;
        color: #ffffff;
        margin-left: 10px;
      }
    }
    .coupon-list {
      margin: 15px 18px 25px 18px;
      border-top: 1px solid #eeeeee;
      .coupon-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 8px 0;
        border-bottom: 1px solid #eeeeee;
        input {

        }
        p {
          color: #808080;
          font-size: 10px;
        }
      }
    }
    .ensure-btn {
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #b50000;
      color: #ffffff;
      font-size: 18px;
      text-align: center;
    }
  }
</style>
<script>
import Popup from './common/Popup'
    export default{
        data() {
          return {
            api: this.$store.state.api,
            BASE_URL: BASE_URL,
            showCoupon: false,
            showEdit: false,
            checkedNo: [],
            cartId: '',
            mainList: [],
            itemList: [],
            dAddressNo: '',
            finalPrice: '',
            freight: '',
            totalQuantity: '',
            totalHeadDiscount: '',
            promotion_item: [],
            promotion_head: [],
            isShowPromotion: true,
            popupTitle: '',
            popupDes: '',
            popupType: 0,
            popupShow: false
          }
        },
        created() {
          this.cartId=localStorage.getItem("cartId");
          if(this.$route.query.code) {
            this.applyCoupon();
          }else {
            this.getCart();
          }

        },
        components: {
          Popup
        },
        computed: {
          totalDiscount() {
            var d = 0;
            for(var i=0;i<this.mainList.length;i++) {
              d+=this.mainList[i].discount/1;
            }
            return d+this.totalHeadDiscount/1;
          }
        },
        methods: {
          showFreight() {
            this.popupTitle = '运费说明'
            this.popupDes='单笔订单满200元可免运费;</br>最终运费已订单页面为准;';
            this.popupType=4;
            this.popupShow=true;
          },
          hidePopup() {
            this.popupShow=false;
          },
          closePromotion() {
            this.isShowPromotion = false;
          },
          selectCoupon(_8d) {
            let url=`${BASE_URL}/content/dam/sonystyle-club/index.html?productCode=${_8d}#/coupon`;
            window.location.href = url;
          },
          applyCoupon(){
            let url = this.api.coupon.applyCoupon(this);
            this.$http.post(url,{
              couponCode: this.$route.query.code,
              cartID: this.cartId
            })
            .then(res=>{
               this.getCart();
            })
            .catch(err=>{

            })
          },
          removeCoupon(_code) {
            let url = this.api.coupon.removeCoupon(this);
            this.$http.post(url,{
              couponCode: _code,
              cartID: this.cartId
            })
            .then(res=>{
              if(res.data.code=='00'){
                this.getCart();
              }
            })
          },
          editCart(info) {
            this.showEdit = !this.showEdit;
          },
           getCart() {
              let url = this.api.cart.readCart(this);
              this.$http.post(url,{})
              .then(res=>{
                if(res.data.resultMsg&&res.data.resultData){
                   this.itemList = res.data.resultData.itemList;
                   this.cartId=res.data.resultData.header.cartId;
                   localStorage.setItem("cartId",this.cartId);
                   this.dAddressNo = res.data.resultData.header.dAddressNo;
                   this.finalPrice = res.data.resultData.header.finalPrice;
                   this.freight = res.data.resultData.header.freight;
                   this.totalQuantity = res.data.resultData.header.totalQuantity;
                   this.totalHeadDiscount = res.data.resultData.header.totalHeadDiscount;
                   if(this.itemList) {
                    this.resolveList(this.itemList);
                   }else {
                     this.mainList = [];
                   }
                   this.getPromotion();
                }
              })
              .catch({

              })
           },
           pop() {
             if(this.checkedNo.length<1) {
              return;
             }
              this.popupDes='请问您确认将选中商品删除吗?';
              this.popupType=1;
              this.popupShow=true;
           },
           removeOrMove(_action) {
            switch(_action) {
              case 'moveAll':
                for(var i=0;i<this.checkedNo.length;i++){
                  this.moveWishlist(this.checkedNo[i],'','D');
                };
                break;
              case 'move':
                for(var i=0;i<this.checkedNo.length;i++){
                  this.moveWishlist(this.checkedNo[i],'','D');
                };
                break;
              case 'delete':
                for(var i=0;i<this.checkedNo.length;i++){
                  this.changeCart(this.checkedNo[i],'','D');
                };
                break;
              default:
                break;
            }
            this.hidePopup();
            this.checkedNo=[];
           },
           changeCart(_No,_quantity,_action) {
            if(_action=='U'&&_quantity<1){
              //this.popupTitle = '运费说明'
              this.popupDes='不能再减少咯^-^';
              this.popupType=4;
              this.popupShow=true;
              return;
            }
            let url = this.api.cart.changeCart(this);
            this.$http.post(url,JSON.stringify({
              entryNumber: _No,
              quantity: _quantity,
              actionType: _action,
            })
            ).then(res=>{
                if(res.data.resultMsg&&res.data.resultData){
                   this.itemList = res.data.resultData.itemList;
                   this.cartId = res.data.resultData.header.cartId;
                   this.dAddressNo = res.data.resultData.header.dAddressNo;
                   this.finalPrice = res.data.resultData.header.finalPrice;
                   this.freight = res.data.resultData.header.freight;
                   this.totalQuantity = res.data.resultData.header.totalQuantity;
                   this.totalHeadDiscount = res.data.resultData.header.totalHeadDiscount;
                   if(this.itemList){
                    this.resolveList(this.itemList);
                 }else {
                   this.mainList = [];
                 }
                 this.getPromotion();
                }else if(res.data.resultMsg[0].code=='99'){
                  this.popupDes=res.data.resultMsg[0].message;
                  this.popupType=4;
                  this.popupShow=true;

                }
              })
              .catch({

              })
           },
           moveWishlist(_No) {
            let url = this.api.cart.moveToWishlist(this);
            this.$http.post(url,JSON.stringify({
              entryNumber: _No
            })
            ).then(res=>{
                if(res.data.resultMsg&&res.data.resultMsg[0].code=='00'){
                   this.getCart();
                }
              })
              .catch({

              })
           },
           getPromotion() {
            let url = this.api.promotion.getCartPromotions(this);
            this.$http.post(url,JSON.stringify({
              cartID: this.cartId
            }))
            .then(res=>{
              if(res.data.resultMsg[0].code=='00'&&res.data.resultMsg[0].message=='Success'){
                this.promotion_item = res.data.resultData.promotion_item;
                this.promotion_head = res.data.resultData.promotion_head;
              }
            })
            .catch({

            })
           },
            resolveList(data) {
                this.mainList = [];
                var url = this.api.product.findMasterData();
                for(let i=0;i<data.length;i++){
                    if(data[i].mainProduct=='Y'){
                        data[i].foc = [];
                        for(let l=0;l<data.length;l++){
                          let focItem = data[l];
                          if(data[l].mainProduct=='N' && data[i].product8D==data[l].parent8D){
                              this.$http.get(url,
                                {
                                  params: {
                                  'eightD': focItem.product8D
                                  }
                                }
                              ).then(res=>{
                                if(res.data.result && res.data.code=='00') {
                                  console.log(data[l].product8D+':'+res.data.returnData.OutMasterData.imagePath)
                                  focItem.imgURL = res.data.returnData.OutMasterData.imagePath;
                                  data[i].foc.push(focItem);
                                }
                              })

                          }
                        }
                        this.$http.get(url,
                          {
                            params: {
                            'eightD': data[i].product8D
                            }
                          }
                        ).then(res=>{
                          if(res.data.result && res.data.code=='00') {
                          console.log(data[i].product8D+':'+res.data.returnData.OutMasterData.imagePath)
                            data[i].imgURL = res.data.returnData.OutMasterData.imagePath;
                            this.mainList.push(data[i]);
                          }
                        })

                    }
                }
            },
            continueCheck() {
              this.$router.push({path:'/SubmitOrder'});
            },
            checkout() {
              let url = this.api.cart.checkout(this);
              this.$http.post(url)
              .then(res=>{
                if(res.data.resultMsg[0].code=='00'){
                   this.$router.push({path:'/SubmitOrder'});
                }else if(res.data.resultMsg[0].code=='01') {
                  this.popupDes='您选择的赠品中有缺货商品</br>选择继续结算,将不能更换赠品';
                  this.popupType=3;
                  this.popupShow=true;
                }
              })
              .catch(res=>{

              })
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/ShopCart.vue